import type {Array, ArrayAddButton} from "@t/fd/layout/Array.ts";
import {getter} from "@fd/Part.ts";
import {injectEnv} from "@fd/Environment.ts";
import {type ComputedRef, unref, toRaw} from "vue";
import {getJson} from "@fd/Backend.ts";


/**
 * @param formData global form data
 * @param array array of items to which the new item will be inserted
 */
export function useAddButton(formData:any, array:ComputedRef<any[]>) {
	const env = injectEnv();

	function completeEndpointUrl(btn: ArrayAddButton, index?: number) {
		let url = btn.endpoint;
		if (!url) throw "Missing endpoint in array part";
		if (Array.isArray(btn.params)) {
			for (let par of btn.params) {
				let v;
				if (par.source === "static") v = par.value;
				else {
					// from data
					v = getter(formData, par.d, formData);
				}
				if (par.path) {
					url = url.replace("{" + par.name + "}", v);
				} else {
					url = env.net.urlParam(url, par.name, v);
				}
			}
		}
		if (typeof index === "number") url = env.net.urlParam(url, "_idx_", array.value.length);
		return url;
	}

	async function buildNewItem(btn: ArrayAddButton, index?: number, defaultValue:any = {}):Promise<any> {
		if (btn) {
			if (btn.init === "endpoint") {
				if (btn.endpoint) {
					let ep = completeEndpointUrl(btn, index);
					return await getJson(env, ep);
				}
			} else if (btn.init === "url") {
				if (btn.endpoint) {
					let url = completeEndpointUrl(btn, index);
					window.location.href = url;
				}
			} else if (btn.init === "value") {
				const original = btn.value;
				return structuredClone(toRaw(unref(original)));	// remove reactivity to be able to clone
			} else if (btn.init === "function") {
				if (typeof btn.value === "function") {
					return btn.value(formData, index);
				} else if (btn.value === "string") {
					const fn = new Function("g", "index", btn.value);
					btn.value = fn;
					fn(formData, index);
				} else console.error("Array add button is of type function but value isn't function nor string (code)");
			}
		}
		return defaultValue;
	}


	function addLabel(btn: ArrayAddButton) {
		return (btn.icon ? " " : "") + (btn.label || env.msg("addItem"));
	}


	return {
		completeEndpointUrl, addLabel, buildNewItem
	}
}